import cookies from "../utils/cookies";
import {mediaMatch} from "../utils";
import {useNavigateTo} from "./useNavigateTo";
import {useDispatch} from "react-redux";
import {setDrawerLogin} from "../reducer/actions";


let loginAfterHandle = null;
let loginAfterQuery = {};

export default function useRequestTokenAuth() {
  const isMdmax = mediaMatch.isMdmax;
  const navigateTo = useNavigateTo();
  const dispatch = useDispatch();
  
  /**
   * 判断请求接口前，有没登录。没有登录，弹出登录框，
   * 将保存触发前的handle及参数保存在内存, 登录后，将重新触发内存中的handle，
   * （只有在登录弹窗中有效，登录页面中无法触发）
   * @param handle
   * @param query
   */
  const fn = (handle, query) => {
    loginAfterHandle = handle;
    loginAfterQuery = query;
    
    if (!cookies.getToken()) {
      let redirect = window.location.hash.replace('#', '');
      
      if (isMdmax) {
        navigateTo('/login' + '?redirect=' + encodeURIComponent(redirect));
      } else {
        if (['1','2', '8', '9'].includes(cookies.get('MALL'))) {
          navigateTo('/login' + '?redirect=' + encodeURIComponent(redirect));
        } else {
          dispatch(setDrawerLogin(true));
        }
      }
  
      return Promise.reject();
    }
  };
  
  const getLoginAfter = () => {
    const isMdmax = mediaMatch.isMdmax;
    if (isMdmax) { // 如果是手机端的话，则返回空handle
      return {
        handle: null,
        query: {}
      };
    }
    
    return {
      handle: loginAfterHandle,
      query: loginAfterQuery
    };
  };
  
  return [fn, getLoginAfter];
}
